module.exports = __webpack_public_path__ + "static/media/2-2_Duplex_White_01.943fe44d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/2-2_Duplex_White_01.jpg
// module id = 1704
// module chunks = 0